import React, { PureComponent } from 'react'
import { Tabs, Tab, Popover, Overlay, Button, Glyphicon } from 'react-bootstrap'
import { urgencyTypesClass } from '../../constants/backendIds'
import { Link } from 'react-router-dom'

const MAX_DOSSIER_TO_VIEW = 10

class DossierListPopover extends PureComponent {
  constructor () {
    super()
    this.state = {
      showPopover: false,
      target: this
    }
  }

  handleClick (e) {
    e.stopPropagation()
    this.setState({ target: e.target, showPopover: true })
  }

  render () {
    const {
      t,
      id,
      alive = [],
      stored = [],
      subtypesCombo
    } = this.props
    const tKey = 'SEARCH.'
    return (
      <div>
        {(stored.length > 0 || alive.length > 0) &&
          <Button bsSize="xsmall" className="icon-only" onClick={this.handleClick.bind(this)}><Glyphicon glyph="plus"/></Button>
        }
        {`${alive.length} ${t(`${tKey}ONTIME`)} / ${stored.filter((dossier) => !dossier.isCancelled).length} ${t(`${tKey}ARCHIVED`)}`}
        <Overlay
          show={this.state.showPopover}
          target={this.state.target}
          onHide={() => this.setState({ showPopover: false })}
          rootClose
          placement={'bottom'}
        >
          <Popover id={id} className="document-count-popover-container">
            <Tabs
              onClick={e => e.stopPropagation()}
              defaultActiveKey={1}
              animation={false}
              id="tab-dossier01"
            >
              <Tab eventKey={1} title={t(`${tKey}ONTIME`)}>
                <div className="popover-document-count">
                  {
                    alive.slice(0, MAX_DOSSIER_TO_VIEW).map((dossier, idx) => (
                      <p key={idx}>
                        <span className={`color-point ${urgencyTypesClass[dossier.urgencyType] || 'grey'}`}/> <Link to={`/dossier${dossier.urlToNavigate}`}>{dossier.number}</Link> - {subtypesCombo && subtypesCombo.find(s => s.id === dossier.dossierSubtypeId) ? subtypesCombo.find(s => s.id === dossier.dossierSubtypeId).value : dossier.dossierSubType}
                      </p>
                    ))
                  }
                </div>
              </Tab>
              <Tab eventKey={2} title={t(`${tKey}ARCHIVED`)}>
                <div className="popover-document-count">
                  {
                    stored.filter((dossier) => !dossier.isCancelled).slice(0, MAX_DOSSIER_TO_VIEW).map((dossier, idx) => (
                      <p key={idx}>
                        <span className="color-point grey"/> <Link to={`/dossier${dossier.urlToNavigate}`}>{dossier.number}</Link> - {subtypesCombo && subtypesCombo.find(s => s.id === dossier.dossierSubtypeId) ? subtypesCombo.find(s => s.id === dossier.dossierSubtypeId).value : dossier.dossierSubType}
                      </p>
                    ))
                  }
                </div>
              </Tab>
            </Tabs>
          </Popover>
        </Overlay>
      </div>
    )
  }
}

export default DossierListPopover
